module.exports = __webpack_public_path__ + "dingbeauty-build/img/store3_small@2.9a1a08de.jpg";